<template>
  <div id="edit-psychologist">
    <Navbar
      current="Editar psicólogo"
      :link="$paths.psychologists.list"
      :sublink="`${$paths.psychologists.detail}/${id}`"
      :linkName="'Psicólogos'"
      :sublinkName="'Detalhes do psicólogo'"
    />
    <Sidebar />
    <Container>
      <Header title="Editar Psicólogo" />
      <LoadingContainer v-if="loadingItems" />
      <div v-else class="card">
        <div class="card-body">
          <form @submit.prevent="submit">
            <h5 class="fw-bold mb-3">Identificação e contato</h5>
            <TextInput
              label="Nome"
              type="text"
              :model="$v.form.name"
              placeholder="Nome completo"
            />
            <TextInput
              label="Email"
              type="email"
              :model="$v.form.email"
              placeholder="Email"
            />
            <div class="row">
              <div class="col-3">
                <TextInput
                  label="Código do país"
                  type="text"
                  :model="$v.form.country_code"
                  placeholder="+55"
                />
              </div>
              <div class="col">
                <TextInput
                  label="Telefone"
                  type="text"
                  :model="$v.form.phone"
                  placeholder="Telefone"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <TextInput
                  label="Data de nascimento"
                  type="date"
                  :model="$v.form.birth_date"
                />
              </div>
              <div class="col-md-6">
                <TextInput
                  label="CPF"
                  type="text"
                  :model="$v.form.document_number"
                  placeholder="CPF"
                  errorMsg="CPF inválido"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <TextInput
                  label="CRP"
                  type="text"
                  :model="$v.form.crp"
                  placeholder="CRP"
                />
              </div>
              <div class="col-md-6">
                <SelectInput
                  label="Gênero"
                  :model="$v.form.gender"
                  :options="genderOptions"
                  propertyForValue="value"
                  propertyForText="label"
                  placeholder="Selecione um gênero"
                />
              </div>
            </div>

            <hr class="my-4" />
            <h5 class="fw-bold mb-3">Endereço</h5>
            <div class="row">
              <div class="col-md-4">
                <TextInput
                  label="CEP"
                  type="text"
                  :model="$v.form.address_postal_code"
                  placeholder="CEP"
                />
                <small v-if="fetchingCep" class="text-muted">
                  <i class="fa-solid fa-spinner fa-spin me-1"></i>
                  Buscando endereço...
                </small>
                <small v-else-if="cepError" class="text-danger">
                  {{ cepError }}
                </small>
              </div>
              <div class="col-md-6">
                <TextInput
                  label="Cidade"
                  type="text"
                  :model="$v.form.address_city"
                  placeholder="Cidade"
                />
              </div>
              <div class="col-md-2">
                <SelectInput
                  label="UF"
                  :model="$v.form.address_state"
                  :options="states"
                  propertyForValue="uf"
                  propertyForText="uf"
                  placeholder="UF"
                />
              </div>
            </div>
            <TextInput
              label="Endereço"
              type="text"
              :model="$v.form.address_line1"
              placeholder="Rua, avenida, etc"
            />
            <TextInput
              label="Complemento"
              type="text"
              :model="$v.form.address_line2"
              placeholder="Número, complemento"
            />

            <div class="row mt-3">
              <div class="col-12 text-center">
                <span class="text-danger text-center">{{ errorMessage }}</span>
              </div>
            </div>

            <div class="d-flex gap-2 justify-content-end mt-4">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="$router.back()"
              >
                Cancelar
              </button>
              <FormButton
                label="Salvar alterações"
                :loading="submitting"
                :disabled="$v.$invalid"
                @onClick="submit"
              />
            </div>
          </form>
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import PsychologistEditController from "./PsychologistEditController";
export default PsychologistEditController;
</script>
